"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationType = void 0;
exports.IntegrationType = {
    McpServer: "mcp_server",
    McpIntegration: "mcp_integration",
};
